<template>
  <div class="h-100 d-block">
    <vue-apex-charts
      type="bar"
      width="100%"
      height="100%"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

export default {
  name: 'InsuranceStackedBarCharts',
  components: {
    VueApexCharts,
  },
  props: {
    seriesData: {
      type: Array,
      required: true,
    },
    categoriesData: {
      type: Array,
      required: true,
    },
    // eslint-disable-next-line vue/require-default-prop
    colorsData: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        colors: [$themeColors.success, $themeColors.warning, $themeColors.danger],
        chart: {
          type: 'bar',
          stacked: true,
          stackType: '100%',
          width: '100%',
          height: '100%',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              total: {
                enabled: false,
                offsetX: 0,
                style: {
                  fontSize: '13px',
                  fontWeight: 900,
                },
              },
            },
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff'],
        },
        xaxis: {
          categories: [],
          labels: {
            formatter(val) {
              return `${val}`
            },
          },
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {
          y: {
            formatter(val) {
              return `${val} adet`
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: 'top',
          horizontalAlign: 'center',
          offsetX: 0,
          offsetY: 0,
        },
      },
    }
  },
  watch: {
    seriesData: 'setData',
    categoriesData: 'setData',
    colorsData: 'setData',
  },
  created() {
    this.setData()
  },
  methods: {
    setData() {
      this.series = this.seriesData
      this.chartOptions.xaxis.categories = this.categoriesData
      if (this.colorsData) {
        this.chartOptions.colors = this.colorsData
      }
    },
  },
}
</script>
